import { RoutePath, ServiceType } from '@common/enums';

export interface ServiceTypeUiInfo {
  serviceType: ServiceType;
  i18nKey: string;
  iconCssClass: string;
  url: (id?: string) => string;
}

const serviceUiInfo = new Map<ServiceType, ServiceTypeUiInfo>([
  [
    ServiceType.All,
    {
      serviceType: ServiceType.All,
      i18nKey: 'page.all',
      iconCssClass: '',
      url: () => ''
    }
  ],
  [
    ServiceType.Users,
    {
      serviceType: ServiceType.Users,
      i18nKey: 'page.users',
      iconCssClass: 'fa fa-users',
      url: () => RoutePath.Users
    }
  ],
  [
    ServiceType.History,
    {
      serviceType: ServiceType.History,
      i18nKey: 'page.history',
      iconCssClass: 'fa fa-history',
      url: (id) => addIdToUrl(RoutePath.History, id)
    }
  ],
  [
    ServiceType.Payments,
    {
      serviceType: ServiceType.Payments,
      i18nKey: 'page.payments',
      iconCssClass: 'fa fa-money',
      url: () => RoutePath.Payments
    }
  ],
  [
    ServiceType.Mail,
    {
      serviceType: ServiceType.Mail,
      i18nKey: 'page.mail',
      iconCssClass: 'fa fa-envelope',
      url: (id) => addIdToUrl(RoutePath.Mail, id)
    }
  ],
  [
    ServiceType.Drive,
    {
      serviceType: ServiceType.Drive,
      i18nKey: 'page.drive',
      iconCssClass: 'ico ico-Drive',
      url: (id) => addIdToUrl(RoutePath.Drive, id)
    }
  ],
  [
    ServiceType.Contacts,
    {
      serviceType: ServiceType.Contacts,
      i18nKey: 'page.contacts',
      iconCssClass: 'fa fa-address-book-o',
      url: (id) => addIdToUrl(RoutePath.Contacts, id)
    }
  ],
  [
    ServiceType.Calendar,
    {
      serviceType: ServiceType.Calendar,
      i18nKey: 'page.calendar',
      iconCssClass: 'ico ico-Calendar',
      url: (id) => addIdToUrl(RoutePath.Calendar, id)
    }
  ],
  [
    ServiceType.TeamDrives,
    {
      serviceType: ServiceType.TeamDrives,
      i18nKey: 'page.sharedDrives',
      iconCssClass: 'ico ico-GoogleDrive',
      url: () => RoutePath.SharedDrives
    }
  ],
  [
    ServiceType.SharePoint,
    {
      serviceType: ServiceType.SharePoint,
      i18nKey: 'page.sharePoint',
      iconCssClass: 'ico ico-SquareS',
      url: () => RoutePath.Sharepoint
    }
  ],
  [
    ServiceType.Teams,
    {
      serviceType: ServiceType.Teams,
      i18nKey: 'page.teams',
      iconCssClass: 'ico ico-SquareT',
      url: () => RoutePath.Teams
    }
  ],
  [
    ServiceType.Export,
    {
      serviceType: ServiceType.Export,
      i18nKey: 'page.exportResults',
      iconCssClass: 'fa fa-download',
      url: () => RoutePath.ExportResults
    }
  ]
]);

/*
 * @param serviceType The service type.
 * @returns UI information for the service.
 */
export function getServiceUiInfo(serviceType: ServiceType): ServiceTypeUiInfo {
  return serviceUiInfo.get(serviceType);
}

/*
 * @param url The base URL.
 * @param id The identifier to append.
 * @returns The URL with the appended identifier, if provided.
 */
function addIdToUrl(url: string, id: string): string {
  return id ? `${url}/${id}` : url;
}
